
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 0C5.463 0 5.208.01 4.408.045c-.799.038-1.342.163-1.82.349a3.673 3.673 0 00-1.33.865 3.66 3.66 0 00-.864 1.329c-.186.478-.312 1.021-.349 1.82C.008 5.208 0 5.462 0 7.5c0 2.037.01 2.292.045 3.092.038.798.163 1.342.349 1.82.191.493.448.912.865 1.33a3.67 3.67 0 001.329.864c.478.185 1.022.312 1.82.349.8.037 1.054.045 3.092.045 2.037 0 2.292-.01 3.092-.045.798-.037 1.342-.164 1.82-.349a3.688 3.688 0 001.33-.865c.415-.417.674-.834.864-1.329.185-.478.312-1.022.349-1.82.037-.8.045-1.055.045-3.092s-.01-2.292-.045-3.092c-.037-.798-.164-1.343-.349-1.82a3.682 3.682 0 00-.865-1.33 3.654 3.654 0 00-1.329-.864c-.478-.186-1.022-.312-1.82-.349C9.792.008 9.537 0 7.5 0zm0 1.35c2.002 0 2.24.01 3.031.044.731.035 1.128.156 1.392.26.351.135.6.298.864.56.262.262.424.512.56.863.102.264.225.66.258 1.392.036.791.044 1.028.044 3.031 0 2.002-.01 2.24-.046 3.031-.039.731-.16 1.128-.264 1.392-.14.351-.299.6-.562.864a2.342 2.342 0 01-.862.56c-.262.102-.666.225-1.397.258-.796.036-1.03.044-3.037.044-2.007 0-2.241-.01-3.037-.046-.732-.039-1.135-.16-1.397-.264-.356-.14-.6-.299-.862-.562a2.278 2.278 0 01-.563-.862c-.103-.262-.224-.666-.262-1.397-.028-.787-.038-1.03-.038-3.027 0-1.998.01-2.242.038-3.038.038-.732.16-1.134.262-1.397.132-.356.3-.6.563-.863.262-.262.506-.43.862-.561.262-.104.657-.226 1.388-.263.797-.028 1.031-.038 3.037-.038l.028.019zm0 2.299a3.851 3.851 0 100 7.702 3.851 3.851 0 000-7.702zM7.5 10a2.5 2.5 0 11-.001-4.999A2.5 2.5 0 017.5 10zm4.904-6.503a.9.9 0 11-1.802-.001.9.9 0 011.802 0z","fill":"#002823"}})])
          )
        }
      }
    